import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"

import { Link, palette, Typography } from "@callcenter/voiso-design-system"

import { authActions, RootState } from "./ducks"
import { ClusterData, BrandingData } from "./types"
import { LoginForm, SelectionForm } from "./modules"

import styles from "./login.module.scss"

const Login = () => {
  const dispatch = useDispatch()
  const isSelectionView =
    useSelector<RootState, Array<ClusterData>>(({ authorization }) => authorization.clusters).length > 1
  const { brandDomainName, brandLogoUrl, brandName } = useSelector<RootState, BrandingData>(
    ({ authorization }) => authorization.branding
  )
  const brandingLoaded = useSelector<RootState, boolean>(({ authorization }) => authorization.brandingLoaded)

  useEffect(() => {
    dispatch(authActions.fetchBrandingStarted())

    return () => {
      dispatch(authActions.reset())
    }
  }, [])

  if (!brandingLoaded) return null

  return (
    <div className={styles.page}>
      <div className={styles.loginContainer}>
        <Link href={`https://${brandDomainName}`}>
          <img alt={brandName} src={brandLogoUrl} className={styles.logo} />
        </Link>

        <div className={styles.formContainer}>
          <div className={styles.formHeader}>
            <Typography.Heading3>Login</Typography.Heading3>
            <Typography.Body2 color={palette.gray8}>
              {isSelectionView
                ? `Select the ${brandName} cluster hosting your contact center`
                : `Login with your ${brandName} ID to access your account`}
            </Typography.Body2>
          </div>

          {isSelectionView ? <SelectionForm /> : <LoginForm />}
        </div>

        {!isSelectionView && (
          <div className={styles.formFooter}>
            <Typography.Body2 color={palette.gray7}>
              Forgot password? Contact{" "}
              <Link href={`mailto:support@${brandDomainName}`}>{`support@${brandDomainName}`}</Link>
            </Typography.Body2>
            <Typography.Body2 color={palette.gray7}>
              Don&apos;t have account yet?{" "}
              <Link href={`https://${brandDomainName}/request-a-demo`}>Contact us to get a free trial</Link>
            </Typography.Body2>
          </div>
        )}
      </div>
    </div>
  )
}

export { Login }
